/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import numeral from 'numeral';

interface Props {
  label: string;
  icon?: React.Element;
  value?: number;
  isSmall?: boolean;
}

const defaultProps = {
  icon: undefined,
  value: undefined,
  isSmall: false
};

const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  fontWeight: theme.fontWeight.normal
}));

const StatPrefix = styled.div(({ isSmall }) => ({
  display: 'flex',
  flexBasis: '2em',
  flexGrow: 0,
  flexShrink: 0,
  fontSize: isSmall ? '0.6em' : '1.25rem',
  justifyContent: 'center'
}));

const StatMain = styled.div({
  flexBasis: 'auto',
  flexGrow: 0,
  flexShrink: 0
});

const StatValue = styled.div(({ isSmall }) => ({
  fontSize: isSmall ? '1em' : '1.75em',
  fontWeight: 200,
  lineHeight: 1,
  position: 'relative'
}));

const StatLabel = styled.div(({ theme, isSmall }) => ({
  fontSize: isSmall ? '0.5em' : theme.fontSize.tiny
}));

function StatBox({ icon, label, value, isSmall }: Props) {
  return (
    <Wrapper>
      <StatPrefix isSmall={isSmall}>{icon}</StatPrefix>
      <StatMain>
        <StatValue isSmall={isSmall}>
          {typeof value === 'number' ? numeral(value).format('0,0.0') : '–'}
        </StatValue>
        <StatLabel isSmall={isSmall}>{label}</StatLabel>
      </StatMain>
    </Wrapper>
  );
}

StatBox.defaultProps = defaultProps;

export default StatBox;
